<template>
  <div>
    <div class="hint-box">
      <div>注意：</div>
      <p v-if="info.fullScope"> 1.当前账号（ADMIN / 大区数据管理员）可选择平台任意有报名记录的会议，导出平台全部参会人员。表格包含会议名称、会议发布时间、会议开始时间、会议结束时间，不包含电话号码和详细地址。<br />
        2.为了数据完整，下载的文件只保留3天的有效期，过了就自动删除记录和文件。请早些下载！<br />
        3.导出表格如果等待时间太长，可以关闭标签页，或关闭浏览器，下载完成后即可直接下载文件</p>
      <p v-else-if="info.marketingScope"> 1.可选择有当前营销经理管辖客户报名的全部会议，不要求会议由本人发布；仅导出管辖客户名下的参会人员。表格包含会议名称、会议发布时间、会议开始时间、会议结束时间，不包含电话号码和详细地址。<br />
        2.下载文件保留3天，请及时下载。<br />
        3.生成文件期间可离开页面，返回后刷新下载记录查看结果。</p>
      <p v-else> 1.仅可选择本人发布的会议，导出本大区管辖客户名下的参会人员。表格包含会议名称、会议发布时间、会议开始时间、会议结束时间，不包含电话号码和详细地址。<br />
        2.为了数据完整，下载的文件只保留3天的有效期，过了就自动删除记录和文件。请早些下载！<br />
        3.导出表格如果等待时间太长，可以关闭标签页，或关闭浏览器，下载完成后即可直接下载文件</p>
    </div>
    <div class="filter-container">
      <el-form :model="query" ref="queryForm" :inline="true">
        <el-form-item :label="info.marketingScope ? '当前营销经理：' : '当前大区：'">
          <span class="area-name">{{ info.areaName || '-' }}</span>
          <span class="area-pho" v-if="info.areaPho">（{{ info.areaPho }}）</span>
        </el-form-item>
        <el-form-item label="选择会议：">
          <el-select
            v-model="query.meetingId"
            placeholder="请选择会议"
            filterable
            clearable
            size="small"
            style="width: 320px"
          >
            <el-option v-for="item in info.meetings" :key="item.id" :label="item.title" :value="item.id">
              <span>{{ item.title }}</span>
              <span style="color: #909399; margin-left: 10px">{{ formatDate(item.startTime) }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleDownload" size="mini" :disabled="(!info.areaId && !info.fullScope && !info.marketingScope) || !query.meetingId">导出</el-button>
        </el-form-item>
      </el-form>
      <div v-if="!hasMeetings" class="empty-tip">{{ info.fullScope ? '当前没有有报名记录的会议' : (info.marketingScope ? '当前没有管辖客户报名的会议' : '当前没有本人发布且有本大区报名记录的会议') }}</div>
    </div>
    <task-list v-if="info.areaId || info.fullScope || info.marketingScope" :key="taskCode" ref="taskList" :task-code="taskCode" />
  </div>
</template>

<script>
import areaMeetingExportApi from '@/api/count/areaMeetingExport'
import TaskList from './TaskList'

// 参会人员大区导出任务编码，与后端 MeetingSignUpService_TEEV2.AREA_MEETING_EXPORT_TASK_CODE 保持一致
const TASK_CODE = 'EEForAreaMeetSignUp'

export default {
  components: {
    TaskList
  },
  data() {
    return {
      TASK_CODE,
      info: {},
      query: {
        meetingId: undefined
      }
    }
  },
  computed: {
    taskCode() {
      return this.info.exportTaskCode || TASK_CODE
    },
    hasMeetings() {
      return !!(this.info.meetings && this.info.meetings.length)
    }
  },
  created() {
    this.getInfo()
  },
  methods: {
    /**
     * 获取当前登录账号绑定的大区，以及可导出的会议列表
     */
    getInfo() {
      return areaMeetingExportApi.fetchInfo().then(({ data }) => {
        this.info = data || {}
      })
    },
    formatDate(val) {
      return val ? String(val).replace('T', ' ').slice(0, 16) : ''
    },
    handleDownload() {
      return this.$common.confirm('是否确认导出')
        .then(() => areaMeetingExportApi.exportExcel({
          meetingId: this.query.meetingId
        }))
        .then((res) => {
          if (res.code === '0') {
            setTimeout(() => {
              this.$refs.taskList.doQueryList({ pageNo: 1 })
            }, 1000)
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import './export-common.scss';

.empty-tip {
  color: #909399;
  font-size: 13px;
  padding: 0 0 10px 4px;
}
</style>
